import { fetchNotificationEmails } from './effects';
import { $notificationEmails } from './states';

// Fetch client notification emails
$notificationEmails.on(fetchNotificationEmails.doneData, (_, data) => data);
